module.exports = __webpack_public_path__ + "resources/icon_44_answer.5f7a0efb07326a52.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_44_answer.png
// module id = 438
// module chunks = 0 1 2 3 4